@use '../../../../../../scss/settings/colors.scss';

.container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0;
  .buttonViewContent{
    display: flex;
    justify-content: flex-end;
  }
}

.propertiesContainer {
  background-color: colors.$base-white;
  padding-right: 8px;
  padding-bottom: 4px;
  border-radius: 0;
  width: 100%;
}

.section {
  width: 100%;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
  padding-right: 8px;
}

.sectionTitle {
  font-family: 'SemiBold Inter', sans-serif !important;
  color: colors.$dark-blue;
  font-size: 16px;
  margin-bottom: 16px;
}

.propertyItem {
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }


}

.inputs_container {
  display: flex;
  gap: 2%;
  justify-content: space-between;
  flex-wrap: wrap;

  .propertyItem {
    width: 49%;
  }
}

.propertyValue {
  background-color: colors.$base-white;
  border: 1px solid colors.$base-white;
  border-radius: 4px;
  padding: 12px 16px;
  display: flex;
  justify-items: flex-start;
  min-height: 48px;

  .MuiOutlinedInput-root {
    background-color: colors.$base-white;
    font-family: 'Regular Inter', sans-serif;
    font-size: 14px;
    line-height: 20px;
    &.Mui-focused fieldset {
      border-color: colors.$brand-purple;
    }
  }
}

.MuiGrid-container {
  row-gap: 24px;
}

.MuiGrid-item {
  padding-top: 0 !important;
}